import { Box, CheckBox, Text } from 'grommet';
import React from 'react';
import { PRODUCT } from '../../../services/types';
import translate from '../../../i18n/translate';

const Declaration = ({ product }) => {
    return (
        <Box align='center' justify='center' gap='small' pad={'small'}>
            {product === PRODUCT.MH &&
                <Box width={'large'} gap='small'>
                    <Text>
                        {translate('declaire_assure')}
                    </Text>
                    <CheckBoxWithText
                        text={translate('declaire_entretien')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_vitree')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_aggravant')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_surface')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_habite')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_surface_total')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_usage_exclusif')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_bail')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_metropol')}
                    />
                    <Text style={{ fontWeight: 'bold' }}>
                        {translate('declaire_cliquant')}
                    </Text>
                </Box>
            }
            {product === PRODUCT.MH_TEMPO &&
                <Box width={'large'} gap='small'>
                    <Text>
                        {translate('declaire_assure')}
                    </Text>
                    <CheckBoxWithText
                        text={translate('declaire_entretien')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_vitree')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_aggravant')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_surface')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_habite')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_surface_total')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_usage_exclusif')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_bail')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_metropol')}
                    />
                    <Text style={{ fontWeight: 'bold' }}>
                        {translate('declaire_cliquant')}
                    </Text>
                </Box>
            }
            {product === PRODUCT.PNO &&
                <Box width={'large'} gap='small'>
                    <Text>
                        {translate('declaire_assure')}
                    </Text>
                    <CheckBoxWithText
                        text={translate('declaire_entretien')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_vitree')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_habite')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_surface_total_pno')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_sinistre')}
                    />
                    <CheckBoxWithText
                        text={translate('declaire_metropol_pno')}
                    />
                    <Text style={{ fontWeight: 'bold' }}>
                        {translate('declaire_cliquant')}
                    </Text>
                </Box>
            }
        </Box>
    )
}

const CheckBoxWithText = ({ text }) => (
    <Box direction='row' gap='medium'>
        <CheckBox checked={true} />
        <Text>{text}</Text>
    </Box>
)

export default Declaration;